import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {HomePage} from '../pages/HomePage/HomePage'
import {LifestyleBoulevard} from '../pages/LifestyleBoulevard/LifestyleBoulevard'
import {General} from '../pages/General/General'
import {Test} from '../pages/Test'
import {MyPage} from '../pages/MyPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {Directorio} from '../pages/Directorio/Directorio'
import {Eventos} from '../pages/Eventos/Eventos'
import {Servicios} from '../pages/Servicios/Servicios'
import {MercadoSur} from '../pages/MercadoSur/MercadoSur'
import {Balcony} from '../pages/Balcony/Balcony'
import {Contacto} from '../pages/Contacto/Contacto'
import {Perfil} from '../pages/Perfil/Perfil'
import {useAuth} from '../modules/auth'
import { Marcas } from '../pages/Marcas/Marcas'
import { Productos } from '../pages/Catalogo/Productos'
import { Generales } from '../pages/Generales/Generales'
import { Distribuidores } from '../pages/Distribuidores/Distribuidores'
import { ListasPrecios } from '../pages/ListasPrecios/ListasPrecios'
import { Pedidos } from '../pages/Pedidos/Pedidos'
import { MisPedidos } from '../pages/MisPedidos/MisPedidos'
import { MiPerfil } from '../pages/MiPerfil/MiPerfil'
import { PedidosVendedor } from '../pages/PedidosVendedor/PedidosVendedor'
import { PerfilVendedor } from '../pages/PerfilVendedor/PerfilVendedor'
import { Vendedores } from '../pages/Vendedores/Vendedores'
import { Administradores } from '../pages/Administradores/Administradores'
import {RoleGuard} from './RoleGuard'
import {getInitialRoute} from './roleRouting'

const PrivateRoutes = () => {
  const {currentUser} = useAuth()

  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        {(() => {
          if (currentUser) {
            return (
              <Route
                path='auth/*'
                element={<Navigate to={getInitialRoute(currentUser.rol)} />}
              />
            )
          }
        })()}
        <Route element={<RoleGuard allowedRoles={['Admin', 'Diseño']} />}>
        <Route path='homepage' element={<HomePage />} />
        <Route path='marcas' element={<Marcas />} />
        <Route path='generales' element={<Generales />} />
        </Route>
        <Route element={<RoleGuard allowedRoles={['Admin', 'Gestor de Catálogo']} />}>
          <Route path='catalogo/productos' element={<Productos />} />
        </Route>
        {/* <Route path='auth/*' element={<Navigate to='/homepage' />} /> */}
        <Route element={<RoleGuard allowedRoles={['Admin']} />}>
        {/* Admin pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        <Route path='lifestyleboulevard' element={<LifestyleBoulevard />} />
        <Route path='directorio' element={<Directorio />} />
        <Route path='eventos' element={<Eventos />} />
        <Route path='servicios' element={<Servicios />} />
        <Route path='mercadosur' element={<MercadoSur />} />
        <Route path='balcony' element={<Balcony />} />
        <Route path='contacto' element={<Contacto />} />
        <Route path='general' element={<General />} />
        <Route path='test' element={<Test />} />
        <Route path='my-page' element={<MyPage />} />
        <Route path='administradores' element={<Administradores />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        </Route>
        <Route element={<RoleGuard allowedRoles={['Admin', 'Gerente Comercial']} />}>
          <Route path='distribuidores' element={<Distribuidores />} />
          <Route path='vendedores' element={<Vendedores />} />
          <Route path='portal/listas-precios' element={<ListasPrecios />} />
          <Route path='portal/pedidos' element={<Pedidos />} />

        </Route>
        <Route element={<RoleGuard allowedRoles={['Admin', 'Gerente Comercial', 'Gestor de Catálogo', 'Diseño']} />}>
          <Route path='perfil' element={<Perfil />} />
        </Route>
        <Route element={<RoleGuard allowedRoles={['Distribuidor']} />}>
          <Route path='portal/mis-pedidos' element={<MisPedidos />} />
          <Route path='portal/mi-perfil' element={<MiPerfil />} />
        </Route>
        <Route element={<RoleGuard allowedRoles={['Vendedor']} />}>
          <Route path='portal-vendedor/mis-pedidos' element={<PedidosVendedor />} />
          <Route path='portal-vendedor/mi-perfil' element={<PerfilVendedor />} />
        </Route>
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary-light-dark')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
